import * as Utils from "./modules/utils";
import "./modules/navigation";
import * as Toggles from "./modules/toggles";
import * as AppPages from "./modules/app-pages";
import * as Forms from "./modules/forms";
import * as Freeform from "./modules/freeform";
import * as Sliders from "./modules/sliders";
import * as FeatureVideos from "./modules/feature-videos";
import * as PrimaryVideos from "./modules/primary-videos";
import * as Maps from "./modules/maps";
import * as Tabs from "./modules/tabs";
import * as VR from "./modules/vr";
import * as Search from "./modules/search";
import * as AdvancedForms from "./modules/advanced-forms";
import * as GivingForm from "./modules/giving-form";
import * as Timeline from "./modules/timeline";
import * as NewsEvents from "./modules/news-events";
import * as AutoUpdate from "./modules/auto-updated-pages";
import * as Announcement from "./modules/announcement";
import * as Cloudbeds from "./modules/cloudbeds";
import * as FullscreenGallery from "./modules/fullscreen-gallery";
import * as Shop from "./modules/shop";

Utils.buildPage();

// Event Maps
if (
    document.querySelector(".js-map") &&
    typeof window.google.maps !== "undefined"
) {
    Maps.init();
}

// Mailchimp Form
if (document.querySelector(".js-mailchimp-form")) {
    Forms.init();
}

// Cloudbeds
if (document.querySelectorAll(".js-cloudbeds").length) {
    Cloudbeds.init();
}

// FreeForm
if (document.querySelectorAll(".js-freeform")) {
    Freeform.init();
}

// Scroll Links
if (document.querySelector(".js-scroll-to-course")) {
    Utils.scrollToTarget(".js-scroll-to-course", 96);
}

// Search
if (document.querySelector(".js-search-result")) {
    Search.init();
}

// Advanced Forms
if (document.querySelector(".js-form-block")) {
    AdvancedForms.init();
}

// Giving Forms
// if (document.querySelector('.js-form-giving')) {
//     GivingForm.init();
// }

// News/Events
if (document.querySelectorAll(".js-news-events-container").length) {
    NewsEvents.init();
}

// Timeline
if (document.querySelector(".js-timeline")) {
    Timeline.init();
}

// 360 VR
if (document.querySelectorAll(".js-360-vr").length && window.pannellum) {
    VR.init();
}

// Shop Product
if (document.querySelector(".js-product")) {
    Shop.product();
}

// Shop Cart
if (document.querySelector(".js-cart")) {
    Shop.cart();
}

// Shop Checkout
if (document.querySelector(".js-checkout")) {
    Shop.checkout();
}

// Initialise Videos (a requirement of the youtube API!)
window.onYouTubeIframeAPIReady = function () {
    FeatureVideos.init();
    PrimaryVideos.init();
};

// Recaptcha init on giving form
// window.givingFormRecaptcha = function () {
//     GivingForm.recaptchaInit();
// }

// Toggle Buttons
Toggles.init();

// Perform browser check
Utils.browserCheck();

// Ready App Page links
AppPages.init();

// Auto updating pages
AutoUpdate.init();

// Announcement Message
Announcement.init();

// Dynamically get the cart count
Shop.getCartCount();

Utils.trackAnchorClicks();
